class CotizacionEnviarRequest {
  postCotizacionEnviar = (datosEnvia) => {
    return {
      datos: {
        correo: datosEnvia.correo,
      },
    };
  };
}

export default CotizacionEnviarRequest;
